document.addEventListener("DOMContentLoaded", function() {
    var botonInicioSesion = document.getElementById('sign_in__button');
    if (botonInicioSesion) {
        botonInicioSesion.addEventListener('click', function() {
            vaciarCarrito();
        });
    }
});

function vaciarCarrito() {
    fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    })
    .then(response => {
        if (response.ok) {
            console.log('Carrito vaciado con éxito');
        }
    })
    .catch(error => {
        console.error('Error al vaciar el carrito:', error);
    });
}